"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(["\n    color: ", ";\n    background: ", ";\n    padding: ", "em\n        ", "em 0;\n    overflow: hidden;\n"], ["\n    color: ", ";\n    background: ", ";\n    padding: ", "em\n        ", "em 0;\n    overflow: hidden;\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactCollapse = require("react-collapse");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Content = _styledComponents2.default.div(_templateObject, function (props) {
    return props.theme.tabordion.content.color;
}, function (props) {
    return props.theme.tabordion.active.background;
}, function (props) {
    return props.theme.tabordion.padding;
}, function (props) {
    return props.theme.tabordion.padding / 2;
});

var AccordionContent = function (_React$Component) {
    _inherits(AccordionContent, _React$Component);

    function AccordionContent() {
        _classCallCheck(this, AccordionContent);

        return _possibleConstructorReturn(this, (AccordionContent.__proto__ || Object.getPrototypeOf(AccordionContent)).apply(this, arguments));
    }

    _createClass(AccordionContent, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                children = _props.children,
                rest = _objectWithoutProperties(_props, ["children"]);

            return _react2.default.createElement(
                _reactCollapse.Collapse,
                rest,
                _react2.default.createElement(
                    Content,
                    null,
                    children
                )
            );
        }
    }]);

    return AccordionContent;
}(_react2.default.Component);

exports.default = AccordionContent;


//////////////////
// WEBPACK FOOTER
// ./~/rla-components/dist/components/accordion/accordionContent.js
// module id = 447
// module chunks = 95715928098905 168707334958949